// @ts-nocheck
import React from 'react';
import { Editor as DraftEditor } from 'react-draft-wysiwyg';
import { ContentState, EditorState } from 'draft-js';
import { StyledTextEditor } from '../../Styled';
import { getCurrentBlock, getEditorBlocksCount, getTextEditorProps } from '../../../utils/textEditor/common';
import { TextEditorToolbar } from '../../../types/textEditor';
import { BLOCK_LENGTH_LIMIT } from '../../../constants/textEditor';
import { useParams } from '@reach/router';
import { CONSOLIDATING, EXTENDING } from '../../../constants';

interface IEditor {
  id: number | string;
  toolbarConfig: TextEditorToolbar;
  editorState: EditorState;
  headingColor?: string;
  listColor?: string;
  blocksLimit: number;
  isLimited: boolean;
  isTitle?: boolean;
  isRight?: boolean;
  onEditorStateChange: (state: EditorState) => void;
  onFocus: () => void;
  onBlur: () => void;
}

export const Editor: React.FC<IEditor> = props => {
  const { stage } = useParams();
  const {
    id,
    toolbarConfig,
    editorState,
    headingColor,
    listColor,
    blocksLimit,
    isLimited = false,
    isTitle = false,
    isRight = false,
    onEditorStateChange,
    onFocus,
    onBlur,
  } = props;

  const isConsolidatingOrExtending = stage === CONSOLIDATING || stage === EXTENDING;

  const subHeadingFontSize = isConsolidatingOrExtending ? 20 : 23;

  const handleReturn = () => {
    const blocksCount = getEditorBlocksCount(editorState);

    return blocksCount >= blocksLimit;
  };

  const handleKeyCommand = (commandName: string) => {
    const blocksCount = getEditorBlocksCount(editorState);

    if (commandName === 'split-block' && blocksCount >= blocksLimit) {
      return 'handled';
    }

    return 'not-handled';
  };

  const handlePastedText = (pastedText: string) => {
    const currentContent = editorState.getCurrentContent();

    const currentStateText = currentContent.getPlainText();
    const updatedStateText = `${currentStateText}${pastedText}`;
    const blocksCount = getEditorBlocksCount(
      EditorState.createWithContent(ContentState.createFromText(updatedStateText))
    );

    const currentBlockText = getCurrentBlock(editorState).getText();
    const updatedCurrentBlockText = `${currentBlockText}${pastedText}`;

    return blocksCount > blocksLimit || updatedCurrentBlockText.length >= BLOCK_LENGTH_LIMIT;
  };

  const handleBeforeInput = () => {
    const currentBlockText = getCurrentBlock(editorState).getText();

    if (currentBlockText.length >= BLOCK_LENGTH_LIMIT) {
      return 'handled';
    }

    return 'not-handled';
  };

  return (
    <StyledTextEditor
      data-testid="styled-text-editor"
      key={id}
      subHeadingFontSize={subHeadingFontSize}
      stage={stage}
      headingColor={headingColor}
      listColor={listColor}
    >
      <DraftEditor
        {...getTextEditorProps(isTitle, isRight)}
        toolbarOnFocus={true}
        stripPastedStyles={true}
        toolbar={toolbarConfig}
        key={id}
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        onFocus={onFocus}
        onBlur={onBlur}
        {...(isLimited && {
          handleReturn,
          handleKeyCommand,
          handlePastedText,
          handleBeforeInput,
        })}
      />
    </StyledTextEditor>
  );
};
